// Chat tab bar + capacity line (approved HTML region).
import type { ReactNode } from 'react';
import type { LiveChatConversation } from '../mockData.js';

export interface ChatBarProps {
  conversations: LiveChatConversation[];
  activeId: string;
  onSelect: (id: string) => void;
  capacity: string;
  /**
   * W37b: right-hand note. The design fixture passes its sample copy; a
   * real session passes an honest statement (rep availability is not a
   * source the queue read exposes).
   */
  sideNote: string;
}

export function ChatBar({
  conversations,
  activeId,
  onSelect,
  capacity,
  sideNote,
}: ChatBarProps): ReactNode {
  return (
    <>
      <div className="capacity">
        <span>
          <strong id="chat-capacity">{capacity}</strong> · Independent drafts and customer context
        </span>
        <span data-testid="live-chat-side-note">{sideNote}</span>
      </div>
      <div
        id="chatbar"
        className="chatbar"
        aria-live="polite"
        role="tablist"
        aria-label="Chat conversations"
      >
        {conversations.map(convo => (
          <button
            key={convo.id}
            role="tab"
            type="button"
            aria-selected={activeId === convo.id}
            className={`chatlabel${activeId === convo.id ? ' selected' : ''}`}
            onClick={() => onSelect(convo.id)}
            data-conversation-id={convo.id}
          >
            <strong>{convo.label}</strong>
            {convo.unreadCount > 0 ? (
              <span className="reply-alert">{convo.unreadCount}</span>
            ) : null}
            <small className="wait-time">{convo.waitLabel}</small>
          </button>
        ))}
      </div>
    </>
  );
}
